import { createSlice } from '@reduxjs/toolkit';
import absWebService from 'app/services/absWebService';
import i18next from 'i18next';
import { showMessage } from 'app/store/abs/messageSlice';

export const communicateWithAPI = (apicall, data, showloading = true) => async dispatch => {

	if (showloading)
		dispatch(setLoading(true));
	const response = await absWebService
		.communicationHandler(apicall, data)
		.catch(error => {
			if (error == null) {
				error = i18next.t("abswebservice:UNKNOWNERROR");
			}
			//give back error for processing below
			return error;
		});

	//await catch error or server response
	const respdata = await response;

	if (showloading)
		dispatch(setLoading(false));

	if (absWebService.isResponseArrSuccess(respdata)) {
		//alert(JSON.stringify(respdata));

		switch (apicall) {
			case "tl_load_all_objectitems":
			case "tl_create_new_objectitem":
			case "tl_edit_objectitem":
				var returndataarr = JSON.parse(absWebService.getDataFromResponseArr(respdata));

				if (data.editindetail == true)
					dispatch(successDetailsFetch(returndataarr));
				else
					dispatch(successBaseFetch(returndataarr));
				break;
			case "tl_load_archived_objectitems":
				var returndataarr = JSON.parse(absWebService.getDataFromResponseArr(respdata));

				dispatch(successArchivedFetch(returndataarr));
				break;
			case "tl_get_objectitemdetailsdata":
				var returndataarr = JSON.parse(absWebService.getDataFromResponseArr(respdata));

				dispatch(successDetailsFetch(returndataarr));
				break;
			case "tl_change_objectitemview":
				var returndataarr = JSON.parse(absWebService.getDataFromResponseArr(respdata));

				dispatch(successViewChangeFetch(returndataarr));
				break;
			case "tl_do_objectitemassignment":
				var returndataarr = JSON.parse(absWebService.getDataFromResponseArr(respdata));

				dispatch(succesProjectAssignmentFetch(returndataarr));
				break;
			case "tl_seal_daterange":
				// No success message for sealing operations
				break;
			case "tl_batch_save_objectitem_milestones":
				// Milestones saved - reload the objectitem details to get updated milestones
				var returndataarr = JSON.parse(absWebService.getDataFromResponseArr(respdata));
				if (returndataarr && returndataarr.milestones) {
					// Update the milestones in the state
					dispatch(updateMilestones(returndataarr.milestones));
				}
				break;
			default:
				dispatch(showMessage({ message: "success fetching data", variant: 'success' }));
				break;
		}

		return absWebService.getDataFromResponseArr(respdata);
	}
	else {
		var errormessage = absWebService.getDisplayTextFromResponseArr(respdata);
		dispatch(showMessage({ message: errormessage, variant: 'error' }));
		return "error";
	}
};

const initialState = {
	loading: true,
	openProjectDialog: false,
	projectToEdit: null,
	canCreateNewProjects: true,
	possibleAssignments: [],
	countriesWithProvinces: [],
	currentObject: [],
	allProjectsData: [],
	allArchivedProjectsData: [],
	objectItemDetailsData: [],
};

const objectitemSlice = createSlice({
	name: 'timeliteObjectitem/projects',
	initialState,
	reducers: {
		setLoading: (state, action) => {
			state.loading = action.payload;
		},
		resetProjects: (state, action) => {
			state = initialState;
		},
		successBaseFetch: (state, action) => {
			state.loading = false;
			state.openProjectDialog = false;
			state.currentObject = action.payload.currentobject;
			state.allProjectsData = action.payload.ownprojects;
			state.allArchivedProjectsData = [];
			state.canCreateNewProjects = action.payload.cancreateprojects;
			state.possibleAssignments = action.payload.possibleassignments;
			state.countriesWithProvinces = action.payload.countrieswithprovinces;
			//merge possible profilepics again
			var tmp = JSON.parse(JSON.stringify(action.payload.ownprojects));
			tmp?.forEach((el, index) => {
				el.assignedusers?.forEach((el1, index1) => {
					var found = state.possibleAssignments.find((temp) => temp.User_ID == el1.User_ID);
					if (found) {
						tmp[index].assignedusers[index1].ProfilePicture = found.ProfilePicture;
					}
				});
			});
			state.allProjectsData = tmp;
			state.objectItemDetailsData = [];
		},
		successArchivedFetch: (state, action) => {
			state.loading = false;
			state.currentObject = action.payload.currentobject;
			state.allArchivedProjectsData = action.payload.archivedprojects;
			//merge possible profilepics again
			var tmp = JSON.parse(JSON.stringify(action.payload.archivedprojects));
			tmp?.forEach((el, index) => {
				el.assignedusers?.forEach((el1, index1) => {
					var found = state.possibleAssignments.find((temp) => temp.User_ID == el1.User_ID);
					if (found) {
						tmp[index].assignedusers[index1].ProfilePicture = found.ProfilePicture;
					}
				});
			});
			state.allArchivedProjectsData = tmp;

		},
		successDetailsFetch: (state, action) => {
			state.allProjectsData = [];
			state.allArchivedProjectsData = [];
			state.countriesWithProvinces = action.payload.countrieswithprovinces;
			state.currentObject = action.payload.currentobject;
			state.objectItemDetailsData = action.payload.objectitemdetailsdata;
			state.possibleAssignments = action.payload.possibleassignments;
			state.loading = false;
		},
		successViewChangeFetch: (state, action) => {
			state.loading = false;
			state.objectItemDetailsData.assignedusers = action.payload;
		},
		succesProjectAssignmentFetch: (state, action) => {
			state.loading = false;
			state.objectItemDetailsData.allassignedentries = action.payload;
		},
		updateMilestones: (state, action) => {
			state.loading = false;
			if (state.objectItemDetailsData) {
				state.objectItemDetailsData.milestones = action.payload;
			}
		},
		setObjectitemDetailsPreLoadObjectitem: (state, action) => {
			state.loading = false;
			state.objectItemDetailsData = [];
			state.objectItemDetailsData.objectitem = action.payload;
		},
		closeProjectDialog: (state, action) => {
			state.openProjectDialog = false;
			state.projectToEdit = null;
		},
		openProjectDialog: (state, action) => {
			state.openProjectDialog = true;
			state.projectToEdit = action.payload;
		},
	},
	extraReducers: {}
});

export const { setLoading, successBaseFetch, successArchivedFetch, successDetailsFetch, setObjectitemDetailsPreLoadObjectitem, successViewChangeFetch, succesProjectAssignmentFetch, updateMilestones, resetProjects, openProjectDialog, closeProjectDialog } = objectitemSlice.actions;

export default objectitemSlice.reducer;
